<div class="form-error is-visible" *ngIf="whitelistFormControl.getError('blacklistedCharacter')">
    {{whitelistFormControl.getError('illegalCharacters')}}
</div>